import { set_timeout } from '@/utils/utils_client';
import { useCallback, useRef } from 'react';
import { use_effect } from './_base/use_effect';

export function HOOK__run_on_next_frame() {
  const ref_timeout = useRef<number>(NaN);

  /*
   * EFFECTS
   */
  use_effect(() => {
    return () => clear_timeout();
  });

  /*
   * METHODS
   */

  function clear_timeout() {
    if (isNaN(ref_timeout.current)) return;
    clearTimeout(ref_timeout.current);
    ref_timeout.current = NaN;
  }

  const out = useCallback((callback: VoidFunction) => {
    clear_timeout();

    ref_timeout.current = set_timeout(() => {
      callback();

      ref_timeout.current = NaN;
    }, 0); // Schedule for next macrotask
  }, []);

  return out;
}
